module.exports = __webpack_public_path__ + "static/img/oprCt_bg_03.6b5e0bfb.svg";